"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var common_1 = require("docs/common");
var components_1 = require("components");
var componentStyle = {
    base: {
        height: 350,
    },
};
var description = 'This is how you get it if you don"t pass any props. ' +
    'You can see just the expand icon, but when you click, it expands, showing its subitems.';
var code = "import React from 'react';\nimport { Drawer, DrawerItem } from c-react-ui';\n\nconst style = {\n  height: 350,\n};\n\nconst DrawerItemExample = () => (\n  <Drawer style={componentStyle.base}>\n    <DrawerSubitemsContainer text=\"Media\">\n      <DrawerItem text=\"Musics\" subitem />\n      <DrawerItem text=\"Videos\" subitem />\n    </DrawerSubitemsContainer>\n  </Drawer>\n);";
exports.ContentExampleDrawerSubitemsContainer = function () { return (React.createElement(common_1.Example, { title: "Content", description: description, code: code },
    React.createElement(components_1.Drawer, { style: componentStyle.base },
        React.createElement(components_1.DrawerSubitemsContainer, { text: "Media" },
            React.createElement(components_1.DrawerItem, { text: "Musics", subitem: true }),
            React.createElement(components_1.DrawerItem, { text: "Videos", subitem: true }))))); };
exports.ContentExampleDrawerSubitemsContainer.displayName = 'ContentExampleDrawerSubitemsContainer';



//////////////////
// WEBPACK FOOTER
// ./src/docs/pages/ComponentDrawerSubitemsContainerPage/ContentExampleDrawerSubitemsContainer.tsx
// module id = 665
// module chunks = 0